export default "__VITE_ASSET__weg7EN$o__"